const yup = require("yup");
const specialChars = " !\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
module.exports = yup
  .string()
  .min(8, "At least 8 characters long")
  .matches(
    new RegExp(`[${specialChars}]`),
    `Use a least one special character (${specialChars})`
  )
  .required("A password is required");
